import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetHotelRoom, useUpdateHotelRoom } from "@/hooks/hotel-rooms";
import { CreateHotelRoom, HotelRoom } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute(
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, rid } = Route.useParams();

  const { isLoading, data: model } = useGetHotelRoom(id, rid);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} hotelId={id} />;
}

function Edit({ model, hotelId }: { model: HotelRoom; hotelId: string }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateHotelRoom(hotelId, {
    onSuccess: (room) => {
      navigate({
        to: "/hotel-rooms/$id",
        params: { id: room.hotelId!.toString() },
      });
    },
  });

  const update = async (room: CreateHotelRoom) => {
    await mutateAsync({ id: model.id, ...room });
  };
  return <Form model={model} onUpsert={update} hotelId={hotelId} />;
}
